import {ListConfigNamedColumn} from '@src/@types/components/List';
import ListColumn from './ListColumn';
import {IListConfigSelectColumn} from '@src/@interfaces/components/List/IListConfigSelectColumn';
import {IEmptyModel} from '@src/@interfaces/IEmptyModel';
import TextColumn from '@src/components/List/columns/TextColumn';

export default class SelectColumn<
        Model extends IEmptyModel = IEmptyModel,
        Config extends IListConfigSelectColumn = IListConfigSelectColumn
> extends ListColumn<ListConfigNamedColumn<Config>, Model> {
    protected baseValueProcessor!: (value: any) => any;

    constructor(props: any) {
        super(props);

        this.baseValueProcessor = super.processValue.bind(this);
    }

    protected get value(): any {
        return this.resolveSelectStatement()?.join(';');
    }

    protected processValue(value: any): any {
        value = TextColumn.truncateValue(value, {
            truncateTo: this.props.config.truncate,
            controllerName: this.props.controllerName,
            modelId: this.props.model.id,
            columnName: this.props.config.name,
            valueProcessor: this.baseValueProcessor,
        });

        return super.processValue(value);
    }

    protected getSelectStatementValueContainer(): Model | Model[] | null {
        return this.model;
    }

    protected resolveSelectStatement(): string[] | null;
    protected resolveSelectStatement(forIndex?: number): string | null;
    protected resolveSelectStatement(forIndex?: number) {
        const model = this.getSelectStatementValueContainer();
        const variable = this.config.select;
        if (!variable || !model) {
            return null;
        }

        const result = (Array.isArray(model) ? model : [model]).map(model => {
            const name = variable.trim();
            const value = Object.values(this.getSelectStatementVariableValue(model, name));

            return value.join(', ');
        });

        if (forIndex != null) {
            return result[forIndex] ?? null;
        }

        return result;
    }

    protected getSelectStatementVariableValue(container: Record<string, any>, property: string): Record<string, any> {
        if (!property) {
            return container;
        }

        if (property in container) {
            return {[property]: container[property]};
        }

        if (!property.includes('.')) {
            return {[property]: container[property] ?? null};
        }

        const segments = property.split('.');
        for (let i = 0; i < segments.length; i++) {
            const segment = segments[i];
            const isIterable = Array.isArray(container) || container != null && typeof container === 'object';

            if (isIterable && (segment in container)) {
                container = container[segment];
            } else if (isIterable && Array.isArray(container) && (segment in (container[0] ?? {}))) {
                const prefix = segments.slice(0, i).join('.');
                const restSegments = segments.slice(i).join('.');

                const result: Record<string, any> = {};
                for (let index = 0; index < container.length; index++) {
                    const nestedResult = this.getSelectStatementVariableValue(container[index], restSegments);
                    for (const [key, value] of Object.entries(nestedResult)) {
                        result[`${prefix}.${index}.${key}`] = value;
                    }
                }

                return result;
            } else {
                return {[property]: null};
            }
        }

        return {[property]: container};
    }
}
